//
//
//

import DynamicForm from '@/components/form/DynamicForm';
export default {
    components: { DynamicForm },
    props: {
        block: { type: Object, required: true }
    },
    computed: {
        formId() {
            const form = this.block.form;
            if (!form) { return ''; }

            return form.id || form.code;
        }
    }
};
